import { Injectable, inject, DOCUMENT } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { LinkDefinition, LinkService } from './link.service';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly linkService = inject(LinkService);
  private readonly document = inject(DOCUMENT);

  setTitle(title: string) {
    this.title.setTitle(title);
  }

  setMetaTags(metaTags: MetaDefinition[]) {
    this.meta.addTags(metaTags);
  }

  setLinkTag(tags: LinkDefinition[]) {
    if (!tags) {
      return;
    }
    for (const element of tags) {
      this.linkService.addTag(element);
    }
  }

  removeMetaTags() {
    const metaTagElements = this.document.getElementsByTagName(
      'meta',
    ) as HTMLCollectionOf<MetaWithCharset>;
    const linkTagElements = this.document.getElementsByTagName('link');
    for (let i = metaTagElements.length - 1; i >= 0; i--) {
      if (
        metaTagElements[i]['name'] !== 'theme-color' &&
        metaTagElements[i]['name'] !== 'robots' &&
        metaTagElements[i]['name'] !== 'google-site-verification' &&
        metaTagElements[i]['name'] !== 'viewport' &&
        metaTagElements[i]['name'] !== 'apple-mobile-web-app-title' &&
        metaTagElements[i]['name'] !== 'application-name' &&
        metaTagElements[i]['name'] !== 'apple-mobile-web-app-status-bar-style' &&
        metaTagElements[i]['name'] !== 'apple-mobile-web-app-capable' &&
        metaTagElements[i]['name'] !== 'mobile-web-app-capable' &&
        !!metaTagElements[i]['charset'] &&
        metaTagElements[i]['name'] !== 'msvalidate.01'
      ) {
        (metaTagElements[i] as any).parentNode.removeChild(metaTagElements[i]);
      }
    }
    for (let i = linkTagElements.length - 1; i >= 0; i--) {
      if (linkTagElements[i]['rel'] === 'canonical') {
        (linkTagElements[i] as any).parentNode.removeChild(linkTagElements[i]);
      }
    }
  }
}

export interface MetaWithCharset extends HTMLMetaElement {
  charset: string;
}
